import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Book: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          fill="#FF612B"
          d="M21.257 11.242H5.695v26.284h15.562c1.328 0 2.562.474 3.605 1.233V14.848c-.095-1.993-1.707-3.606-3.605-3.606ZM30.746 11.242a3.604 3.604 0 0 0-3.605 3.606v23.911c1.043-.759 2.277-1.233 3.605-1.233h15.562V11.242H30.746Z"
        />
        <path
          fill="#002677"
          d="M42.042 17.219H30.75v2.372h11.197c.474 0 .853-.285 1.043-.664.475-.76-.095-1.708-.948-1.708ZM30.75 25.567h11.197c.474 0 .853-.284 1.043-.664.38-.759-.19-1.708-1.043-1.708H30.75v2.372ZM30.75 31.548h11.197c.474 0 .853-.285 1.043-.664.38-.76-.19-1.708-1.043-1.708H30.75v2.372ZM8.07 31.548h11.197c.474 0 .854-.285 1.044-.664.38-.76-.19-1.708-1.044-1.708H8.07v2.372ZM21.26 17.219H8.07v8.35h13.19v-8.35Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.5 0h53.61v48H.5z" />
      </clipPath>
    </defs>
  </Box>
)
export default Book
